import React from 'react';
import Swal from 'sweetalert2';
import { OrderHistoryComponent } from './OrderHistoryComponent';
import {
  OrderHistoryResponse,
  OrderHistoryItem
} from '../../../../../core-module/services/logistics/types';
import { DeliveryInfoResponse } from '../../../../../core-module/services/website/types';
import {
  findDeliveryInfoByDeliveryId,
  findDeliveryMoment,
  hasDeliveryMomentExpired
} from '../../../../../core-module/selectors/Order/selectors';

interface Props {
  readonly orderHistory: OrderHistoryResponse;
  readonly deliveryInfo: DeliveryInfoResponse;
  readonly onEditClick: (existingOrder: OrderHistoryItem) => void;
}

const OrderHistoryContainer: React.FC<Props> = ({ orderHistory, deliveryInfo, onEditClick }) => {
  const editableOrderIds = orderHistory
    .filter((item) => {
      const deliveryInfoItem = findDeliveryInfoByDeliveryId(deliveryInfo, item.delivery_id);

      if (deliveryInfoItem) {
        const deliveryMoment = findDeliveryMoment(
          deliveryInfoItem.deliveryMoments,
          item.delivery_moment_id
        );

        if (deliveryMoment) {
          return !hasDeliveryMomentExpired(deliveryMoment);
        }
      }
      return false;
    })
    .map((item) => item.order_id);

  const handleEditClick = (existingOrder: OrderHistoryItem) => {
    if (existingOrder && existingOrder.is_paid) {
      Swal({
        title: 'Bestelling al gefactureerd',
        text:
          'De bestelling kan niet meer worden gewijzigd omdat deze al is gefactureerd aan de klant.',
        type: 'warning',
        confirmButtonText: 'Ok'
      });
    } else {
      onEditClick(existingOrder);
    }
  };

  return (
    <OrderHistoryComponent
      orderHistory={orderHistory}
      editableOrderIds={editableOrderIds}
      onEditClick={handleEditClick}
    />
  );
};

export { OrderHistoryContainer };
